<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick } from "vue";
import { Globals } from "@/Globals";
import { getMonthNames } from "@/editor/CalenderHelper";
import {
  getValue,
  getKZTitle,
  getKZValueDisplay,
  getKennungValue,
  getColumnByKennung,
} from "@/DataHelper";
import { begriffBezeichnung, globalsBezeichnung } from "@/local";
import { showSnackbar } from "@/UIHelper";
import CalcButton from "@/components/CalcButton.vue";
import { getSiteData, goBack } from "@/NavigationHelper";
import {
  mountedBase,
  onSave,
  BaseSetup,
  reloadData,
  loadAmpel,
} from "@/DataLoaderStatic";
import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
const validator = createEditorValidator();
provideEditorValidator(validator);
const emit = defineEmits(["back", "backDelete"]);
let sperre = ref<boolean>(false);
let titleCard: string = "";
let datenLeer = ref<boolean>(true);
let ampelColor = ref<string>("");
let ampelDaten = ref<number>();
let aicBew: any = undefined;
let modellAic = ref<number>(0);
let antrag = ref<Date | null>(null);
let showSave = ref<boolean>(false);
const siteData = getSiteData();

let items = ref<ListItems[]>([]);
let editZeitbereich: APIZeitbereich | null = null;
let setCompKey = ref<number>(0);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WebAnzeige_monatl_Zulagen",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  try {
    if (siteData.aic) {
      pageParams.aic = siteData.aic;
    }
    modellAic = siteData.aic;
    if (uiData.zeitbereich) {
      editZeitbereich = {
        von: uiData.zeitbereich.von,
        bis: uiData.zeitbereich.bis,
        bereich: "Monat",
      };

      const day = editZeitbereich.von;
      titleCard = getMonthNames()[day.getMonth()];
    }
    loadAmpel(uiData, pageParams, "Web_ZE_Ampel_UestAntrag", false, true, siteData.aic);
    setTimeout(() => {
      setAmpel();
    }, 500);

    await mountedBase(uiData, pageParams);
    if (!uiData.showLoading && uiData.data) {
      refreshItems();
    }
    uiData.showLoading = false;
    uiData.initialized = true;
  } catch (e: any) {
    console.error("mounterror: " + e, e?.stack);
  }
});
function setValue(item: any, index: number, evt: any) {
  uiData.data[index][item.col.name] = evt;
  if (!sperre.value) {
    showSave.value = true;
  }
}
function setAmpel() {
  if (uiData.ampelZulage === 1 || uiData.ampelZulage === 3) {
    sperre.value = true;
    showSave.value = false;
  }
  ampelColor.value = "grey";
  ampelDaten.value = uiData.ampelZulage;
  if (ampelDaten.value === 0) {
    ampelColor.value = "grey";
  } else if (ampelDaten.value === 1) {
    ampelColor.value = "green";
  } else if (ampelDaten.value === 2) {
    ampelColor.value = "orange";
  } else if (ampelDaten.value === 3) {
    ampelColor.value = "red";
  }
  uiData.showLoading = false;
}
async function onValidate() {
  return await validator.validateAsync();
}
async function save(item: any, index: number) {
  uiData.showLoading = true;
  const isvalid = await onValidate();
  if (!isvalid.valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        isvalid.invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    uiData.showLoading = false;
    return;
  }
  uiData.initialized = false;
  if (antrag.value === null) {
    const text = "bitte Daten vollständig erfassen";
    showSnackbar({
      text,
      duration: 4000,
      color: "error",
    });
    uiData.showLoading = false;
    uiData.initialized = true;
    return;
  }
  aicBew = uiData.data[index].aic_Bew_pool;
  const res = await onSave(
    uiData,
    pageParams,
    0,
    "",
    pageParams.zeitbereich,
    pageParams.aic,
    true,
    pageParams.varUebergabe
  );

  saved(res?.data);
}
function saved(res: any) {
  showSave.value = false;
  const updateList = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];

  if (updateList.length > 0) {
    const update = updateList[0];
    uiData.data[0].aic_Bew_pool = update.aic_Bew_pool;

    uiData.columns.forEach((col: DataColumn) => {
      if (update[col.name] !== undefined) {
        uiData.data[0][col.name] = update[col.name];
        if (col.kennung === "ZE_ANTRAG_ZULAGE") {
          const newValue = update[col.name];
          antrag.value = newValue ? new Date(newValue) : null;
        }
      }
    });
  } else if (res?.aic) {
    uiData.data[0].aic_Bew_pool = res.aic;
  }

  refreshItems();
  setCompKey.value += +1;
  nextTick(() => {
    uiData.initialized = true;
    uiData.showLoading = false;
  });
}
// let updateDataForAsync: any = null;
async function onCalculated(args: any) {
  uiData.showLoading = true;
  // loadAmpel brauch ich noch im DataHelperStatic
  const ampel = await loadAmpel(
    uiData,
    pageParams,
    "Web_ZE_Ampel_UestAntrag",
    false,
    true,
    siteData.aic
  );
  if (ampel) {
    setAmpel();
    reloadData(uiData, pageParams);
  }
}

function refreshItems() {
  if (uiData.data.length > 0) {
    datenLeer.value = false;
  }
  items.value = []; // ausleeren für refresh

  for (let i = 0; i < uiData.data.length; i++) {
    const row = uiData.data[i];
    let header = getKZValueDisplay(row, "header", uiData.columns);
    const title = getKZValueDisplay(row, "titel", uiData.columns);
    header = title + " h " + header;

    const col = getColumnByKennung("ZE_ANTRAG_ZULAGE", null, uiData.columns);
    const title2 = getValue(row, col);
    const subtitel = getKZValueDisplay(row, "subtitel", uiData.columns);
    let subtitelHeader = "";
    if (subtitel) {
      subtitelHeader = getKZTitle(row, "subtitel", uiData.columns);
    }

    const color = getKennungValue(row, "FARBE", uiData.columns);

    items.value.push({
      header,
      title,
      title2,
      subtitel,
      subtitelHeader,
      inset: true,
      aic: row.aic_Bew_pool,
      col,
      color,
    });
  }
}
</script>
<template>
  <v-card density="compact" :loading="uiData.showLoading" v-if="uiData.initialized">
    <!-- <v-toolbar density="compact" class="dvhBackground pa-2" style="color: white">
      <v-toolbar-title class="d-flex align-center">
        <span class="text-wrap"> {{ titleCard }}</span>
      </v-toolbar-title>
      <v-spacer />
      <v-btn variant="text" color="white" @click="goBack()" icon="mdi-close"></v-btn>
    </v-toolbar> -->
    <v-card-title>
      <span v-if="datenLeer && !uiData.showLoading">
        {{ begriffBezeichnung("Web_keineDaten_gefunden", "keine Daten gefunden") }}
      </span></v-card-title
    >

    <v-list dense v-if="!datenLeer && !uiData.showLoading">
      <v-list-subheader class="subheader-row">
        <span class="subheader-title"
          >{{
            globalsBezeichnung(
              Globals.Begriff,
              "WebWorkflowAntragUest",
              "Überstunden Antrag"
            )
          }}: {{ titleCard }}</span
        >
        <v-icon
          v-if="ampelDaten"
          size="x-large"
          :color="ampelColor"
          class="subheader-icon"
        >
          mdi-circle-slice-8
        </v-icon>
      </v-list-subheader>
      <v-list-item
        ref="liste"
        v-for="(item, index) in items"
        :key="'c' + index"
        three-line
        class="pa-0"
      >
        <v-card
          class="pa-2"
          :style="{
            border: `1px solid ${item.color || 'green'}`,
            margin: '6px 0',
            borderRadius: '6px',
          }"
        >
          <v-list-item-title>{{ item.header }}</v-list-item-title>
          <v-divider inset></v-divider>
          <v-list-item></v-list-item>

          <v-list-item-subtitle v-if="item.subtitelHeader && item.subtitel">
            {{ item.subtitelHeader }}</v-list-item-subtitle
          >

          <v-list-item-subtitle class="green--text font-weight-bold" v-if="item.subtitel">
            {{ item.subtitel }}</v-list-item-subtitle
          >

          <v-list-item-action
            class="ma-0 px-0 d-flex align-center justify-end inline-actions"
            style="gap: 8px; flex-wrap: nowrap"
            v-if="item.subtitel"
          >
            <EditTimePicker
              :key="'tp-' + index + '-' + setCompKey"
              kennung="ZE_ANTRAG_ZULAGE"
              :isRequired="true"
              v-model="antrag"
              :initValue="item.title2"
              @input="setValue(item, index, $event)"
              @change="showSave = !!$event"
            >
            </EditTimePicker>

            <v-btn
              @click="save(item, index)"
              class="mb-5"
              :disabled="!showSave"
              variant="tonal"
              density="comfortable"
              size="large"
              color="green"
              icon="mdi-content-save"
              rounded="0"
            >
            </v-btn>
          </v-list-item-action>
        </v-card>
      </v-list-item>
    </v-list>
    <v-card-actions v-if="!datenLeer && !uiData.showLoading && !sperre">
      <v-spacer></v-spacer>
      <CalcButton
        active-class="purple white--text"
        :text="
          globalsBezeichnung(Globals.Begriff, 'ZE_Vorg_Freigabe_Uebst_Antrag', 'Freigabe')
        "
        modell="ZE_Vorg_Freigabe_Uebst_Antrag"
        color="success"
        icon="mdi-check"
        variant="plain"
        :small="true"
        :modellAic="modellAic"
        @calculated="onCalculated"
      />
      <CalcButton
        active-class="purple white--text"
        :text="
          globalsBezeichnung(Globals.Begriff, 'ZE_Vorg_Uebst_Ablehnung', 'Anlehnung')
        "
        modell="ZE_Vorg_Uebst_Ablehnung"
        color="error"
        icon="mdi-close"
        variant="plain"
        :small="true"
        :modellAic="modellAic"
        @calculated="onCalculated"
      />
    </v-card-actions>
  </v-card>
</template>
<style scoped>
.subheader-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
/* Ensure the inner Vuetify slot container behaves as a single flex row */
:deep(.subheader-row .v-list-subheader__text) {
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: 100%;
}
.subheader-title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.subheader-icon {
  flex: 0 0 auto;
  margin-left: 8px;
  margin-right: 8px;
}
</style>
